<template>
  <div>
    <v-row>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-stepper v-model="e6">
          <v-stepper-header>
            <v-stepper-step
              class="stepper-header"
              @click="moveStep(1)"
              :complete="e6 > 1"
              step="1"
            >
              Document Tag
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              class="stepper-header"
              @click="moveStep(2)"
              :complete="e6 > 2"
              step="2"
            >
              Document Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              class="stepper-header"
              @click="moveStep(3)"
              step="3"
              :complete="e6 > 3"
            >
              Sender Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              class="stepper-header"
              @click="moveStep(4)"
              step="4"
            >
              Upload Document
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12" elevation="0">
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        :items="allDocumentCategories"
                        label="Document Category"
                        item-value="id"
                        return-object
                        v-model="tag"
                        :readonly="reference_status"
                        @change="changeDocumentTypeSelection()"
                      >
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="allDocumentTypes"
                        label="Select Document Type"
                        item-value="id"
                        v-model="document_type"
                        :readonly="reference_status"
                        return-object
                      >
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="6" v-if="!isStandalone">
                      <v-select
                        :items="document_tags"
                        label="Select Document Tag"
                        v-model="document_tag"
                        item-value="value"
                        :readonly="reference_status"
                      >
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          {{ item.name }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" class="text-center">
                      <p class="red--text" v-if="document_error_msg != null">
                        {{ document_error_msg }}
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <v-btn style="float:right" color="primary" @click="continueStep(1)"> Continue </v-btn>

              <v-btn style="float:right" text @click="close(false)"> Cancel </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-12" elevation="0">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        name="subject"
                        label="Document Subject"
                        required
                        v-model="subject"
                        outlined
                      ></v-textarea>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        aria-autocomplete="off"
                        label="Document Name (optional)"
                        v-model="name"
                        :readonly="reference_status"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        aria-autocomplete="off"
                        label="Document Title (optional)"
                        v-model="title"
                        :readonly="reference_status"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="text-center">
                      <p class="red--text" v-if="document_error_msg != null">
                        {{ document_error_msg }}
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <v-btn style="float:right" color="primary" @click="continueStep(2)"> Continue </v-btn>

              <v-btn style="float:right" text @click="close(false)"> Cancel </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12" elevation="0">
                <v-container>
                  <v-row>
                    <v-col cols="12" v-if="tag.name !== 'Outgoing'">
                      <v-combobox
                        label="Sender"
                        v-model="sender"
                        required
                        :readonly="reference_status"
                        :search-input.sync="search"
                        :items="allSenders"
                        @keydown.enter="openDialog"
                        item-value="id"
                        item-text="label"
                        return-object
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template slot="selection" slot-scope="{ item }">
                          <span v-if="showText"> {{ item.label }} <span class="primary--text">{{ 
                             "- " + item.email
                          }}</span> </span> 
                          
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-item-content>
                            <p class="fullName">
                              {{ item.label }} -
                              <span class="primary--text">{{
                                item.email
                              }}</span>
                            </p>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" v-else>
                      <v-combobox
                        label="Recipient"
                        v-model="sender"
                        required
                        :readonly="reference_status"
                        :items="allUsersByOffice"
                        item-value="user_name"
                        chips
                        small-chips
                        item-text="user_name"
                        return-object
                      >
                        <template slot="selection" slot-scope="{ item }">
                          <v-chip
                            close
                            @click:close="removeSelectedRecipient(item.user_id)"
                          >
                            {{ item.user_name }}
                          </v-chip>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-item-content>
                            <p class="fullName">
                              {{ item.name }} -
                              <span class="primary--text">{{
                                item.user_name
                              }}</span>
                            </p>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" v-if="tag != 3">
                      <v-autocomplete
                        label="Recipient"
                        v-model="document_for"
                        required
                        :readonly="reference_status"
                        :items="allUsersByOffice"
                        item-value="user_name"
                        chips
                        small-chips
                        multiple
                        item-text="user_name"
                        return-object
                      >
                        <template slot="selection" slot-scope="{ item }">
                          <v-chip
                            close
                            @click:close="removeSelectedRecipient(item.user_id)"
                          >
                            {{ item.user_name }}
                          </v-chip>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-item-content>
                            <p class="fullName">
                              {{ item.name }} -
                              <span class="primary--text">{{
                                item.user_name
                              }}</span>
                            </p>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" v-else>
                      <v-combobox
                        label="Recipient"
                        v-model="document_for"
                        required
                        :readonly="reference_status"
                        :items="allSenders"
                      >
                      </v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        aria-autocomplete="off"
                        label="Source"
                        v-model="document_source"
                        required
                        :readonly="reference_status"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        aria-autocomplete="off"
                        label="Address"
                        v-model="address"
                        required
                        hint="Make sure it's easy to remember"
                        :readonly="reference_status"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="text-center">
                      <p class="red--text" v-if="document_error_msg != null">
                        {{ document_error_msg }}
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <v-btn style="float:right" color="primary" @click="continueStep(3)"> Continue </v-btn>

              <v-btn style="float:right" text @click="close(false)"> Cancel </v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="mb-12" elevation="0">
                <v-container>
                  <v-row class="ml-3">
                    <h3>Main Document</h3>    
                  </v-row>
                  <v-col>
                    <v-simple-table
                      fixed-header
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th></th>
                            <th class="text-left">Tracer no.</th>
                            <th class="text-left">File type</th>
                            <th class="text-left">Type</th>
                            <th class="text-right">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><DocumentTypeIcon :type="document.file_type"/></td>
                            <td>{{document.transaction_id}}</td>
                            <td>{{document.file_type.toUpperCase()}}</td>
                            <td>Main Document</td>
                            <td class="text-right">
                              <v-btn depressed small color="primary" @click="previewImage(`${fileSystemUrl}/view/${document.filepath_url}`)" :disabled="document.file_type !== `image`">PREVIEW</v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-row class="mt-5 ml-6" v-if="supp_docs.length > 0">
                    <v-row>
                      <h3>Supporting Document</h3>
                      <v-spacer></v-spacer>
                      <v-btn color="primary mr-9" depressed @click="addDocument()">Add Documents</v-btn>
                    </v-row>
                  </v-row>
                  <v-col v-if="supp_docs.length > 0">
                    <v-simple-table
                      fixed-header
                      height="250px"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th></th>
                            <th class="text-left">File name</th>
                            <th class="text-left">File type</th>
                            <th class="text-left">Type</th>
                            <th class="text-right">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in supp_docs" :key="index">
                            <td><DocumentTypeIcon :type="item.file_type"/></td>
                            <td>{{shortText(item.filepath_url)}}</td>
                            <td>{{item.file_type.toUpperCase()}}</td>
                            <td>Supporting Document</td>
                            <td class="text-right">
                              <v-btn depressed small color="primary" @click="previewImage(`${fileSystemUrl}/view/${item.filepath_url}`)" :disabled="item.file_type !== `image`">PREVIEW</v-btn>
                              <v-btn @click.stop="removeFile(item.id)" icon>
                                <v-icon> mdi-close-circle </v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-card-subtitle>Total: {{supp_docs.length}} file/s uploaded</v-card-subtitle>
                  </v-col>
                </v-container>
              </v-card>

              <v-btn style="float:right" color="primary" @click="add()" :disabled="disableSave"> Upload and Save </v-btn>

              <v-btn style="float:right" text @click="close(false)"> Cancel </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-dialog>
    </v-row>
    
    <AddSupportingDocument
      :dialog="dialogAddSupporting"
      :document_id="id"
      @closeDialog="closeAddSupportingDialog"
      @appendData="appendData"
    />
    <SenderCreateDialog
      :dialog="senderDialog"
      @closeDialog="closeSenderDialog"
      :senderData="search"
    />
    <OutputDocumentDialog
      :dialog="output_dialog"
      :initiatorId="initiatorId"
      @closeDialog="closeReferenceDocumentDialog"
      @referenceDocument="setSelectedReferenceDocument"
    />
    <ImageViewer :dialog="viewImage" :url="object_url" @closeDialog="closeImageView"/>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import axios from "axios";
  import Swal from "sweetalert2";
  import { fileSystemUrl } from "../../../config/config.json";
  import DocumentTypeIcon from "../../common/DocumentTypeIcon.vue"
  import AddSupportingDocument from "../../routes/modal/AddSupportingDocument.vue";
  import OutputDocumentDialog from "../OutputDocumentDialog";
  import { validateDocument } from "../../../store/methods/documentValidate";
  // import DocumentTypeLayout from "../../common/DocumentTypeLayout";
  
  import LoadingOverlay from "../../common/LoadingOverlay.vue";
  import ImageViewer from "../modal/ImageViewer.vue"
  import SenderCreateDialog from "../SenderCreateDialog.vue"
  export default {
    name: "AddDocuments",
    props: {
      dialog: Boolean,
      routeId: Number,
      isMainRoute: Boolean,
      inSubRoutes: Boolean,
      subRouteIndex: Number,
      isStandalone: Boolean,
      accessFrom: String,
      initiatorId: Number,
      document: Object,
      addedReceivers: Array,
    },
    components: {
      OutputDocumentDialog,
      // DocumentTypeLayout,
      LoadingOverlay,
      DocumentTypeIcon,
      SenderCreateDialog,
      AddSupportingDocument,
      ImageViewer
    },
    data() {
      return {
        viewImage:false,
        object_url: null,
        dialogAddSupporting: false,
        file_error_message: "",
        inputFile: null,
        showText: true,
        search: null,
        senderDialog: false,
        disableSave: true,
        e6: 4,
        completed_step: 1,
        acceptedFileTypes: ".png, .jpg , .jpeg, .doc, .docx, .docm, .pdf, .txt, .xls, .xlsb, .xlsm, .xlsx, .ppt, .pptx",
        document_tags: [
          { name: "Supporting", value: "supporting" },
          { name: "Output", value: "output" },
        ],
        category_list: [
          { name: "Incoming Electronic", value: "incoming electronic" },
          { name: "Incoming Physical", value: "incoming physical" },
          { name: "Outgoing", value: "outgoing" },
        ],
        name: "",
        document_type: null,
        file: null,
        title: "",
        sender: "",
        address: "",
        document_for: [],
        document_source: "",
        subject: "",
        type: "supporting",
        filepath_url: null,
        file_type: "file",
        date_uploaded: null,
        errorMessage: null,
        upload_loader: false,
        no_file_error: false,
        disable_upload: false,
        isUploaded: false,
        user_uploaded: null,
        tag: "",
        documentDisplay: "new",
        output_dialog: false,
        reference_status: false,
        referenced_transaction_id: null,
        referenced_document_id: null,
        referenced_refresh_year: null,
        referenced_document_count: null,
        isMainDocument: false,
        document_error_msg: null,
        typeList: [],
        url: null,
        document_tag: "",
        selected_office_filter: null,
        userList: [],
        isFileAttached: false,
        id: null,
        supp_docs: [], 
        loading: false,
        fileSystemUrl: fileSystemUrl
      };
    },
    methods: {
      ...mapActions([
        "fetchDocumentTypes",
        "addRouteDocument",
        "addSubRouteDocument",
        "createDocument",
        "attachRouteDocument",
        "updateDocument",
        "fetchAllSenders",
        "fetchDocumentCategories",
        "fetchUsersInOffice",
        "deleteSupportingDocuments"
      ]),
      appendData(data) {
        data.forEach(d => {
          this.supp_docs.push(d.document)
        })
      },
      addDocument(){
        this.dialogAddSupporting = true
      },
      removeFile(id) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            this.deleteSupportingDocuments([id]).then(() => {
                this.loading = false
                
                const index = this.supp_docs.findIndex(
                  (file) => file.id === id
                );
                if (index > -1) this.supp_docs.splice(index, 1);
                Swal.fire(
                  "Deleted!",
                  "Your file has been deleted.",
                  "success"
                );
        
            });
          }
        });
      },
      closeImageView() {
        this.object_url = null
        this.viewImage = false
      },
      previewImage(url){
        this.object_url = url
        this.viewImage = true
      },
      shortText(name) {
        return name.slice(0, 20).concat("...");
      },
      closeAddSupportingDialog() {
        this.dialogAddSupporting = false
      },
      openDialog(){
        this.sender = {}
        this.showText = false
        let exists = this.allSenders.some(el => el.label === this.search)
        if(!exists)
        this.senderDialog = true;
      },
      closeSenderDialog(){
        this.showText = true;
        this.senderDialog = false;
        this.sender = this.selectedSender
      },
      close(val) {
        this.disableSave = true
        this.file = null;
        this.filepath_url = null;
        this.date_uploaded = null;
        this.name = "";
        this.title = "";
        this.type = "";
        (this.tag = "electronic"), (this.sender = "");
        this.address = "";
        this.document_for = [];
        this.document_source = "";
        this.subject = "";
        this.document_type = null;
        this.file_type = "image";
        this.isUploaded = false;
        this.disable_upload = false;
        this.user_uploaded = null;
        this.$emit("closeDialog", val);
        this.e6 = 1;
        this.completed_step = 1;
        this.document_error_msg = null;
        this.isFileAttached = false;

        this.inputFile = null
        // document.querySelector("#fileUpload").value = "";
      },
      async uploadDocument() {
        this.upload_loader = false;
        this.no_file_error = false;

        if (this.file) {
          this.upload_loader = true;
          const formData = new FormData();
          formData.append("documentFile", this.file, this.file.name);

          try {
            const authToken = localStorage.getItem("access_token");
            const response = await axios.post(
              `${fileSystemUrl}/uploadFile`,
              formData,
              {
                headers: {
                  "x-drmms-token": authToken,
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            this.filepath_url = response.data.filepath_url;
            this.date_uploaded = response.data.date_uploaded;
            this.user_uploaded = response.data.user_id;
            this.disable_upload = true;
            this.isUploaded = true;

            return true;
          } catch (err) {
            console.log(err);
            return {
              error: true,
              errorMessage: "Internal Server Error",
              subtitle: "Unable to upload document",
            };
          }
        } else {
          this.file_error_message = "No file attached"
          this.no_file_error = true;
          return false;
        }
      },
      validateBody() {
        if (!this.file && !this.filepath_url) {
          this.errorMessage = "No file uploaded!";
          console.log("send false");
          return false;
        }

        return true;
      },
      async add() {
        this.disableSave = true;
        let uploadFile = null
        this.loading = true;
        if(this.file){
            uploadFile = await this.uploadDocument();
            if (uploadFile.error) {
            this.disableSave = false;
            Swal.fire({
                icon: "error",
                title: uploadFile.errorMessage,
                text: uploadFile.subtitle,
            });

            return;
            } else if (!uploadFile) return;
        }

        // set documents for data to only user ids
        let document_for = this.document_for.map((e) => e.user_id);


        if (!this.validateBody()) return;

        let body = {
          id: this.id,
          name: this.name,
          type: this.document_type.name,
          tag: this.document_tag,
          document_category: this.tag,
          title: this.title,
          sender: this.sender.name,
          address: this.address,
          for: document_for,
          source: this.document_source,
          subject: this.subject,
          date_uploaded: this.date_uploaded,
          document_type: this.document_type,
          filepath_url: this.filepath_url,
          file_type: this.file_type,
          user_id: this.user_uploaded,
          standalone: this.isStandalone,
        };
        // let addDocument;
        if (this.isStandalone) {
           await this.updateDocument({body: body, supp_docs: this.supp_docs}).then(() => {
            
            this.loading = false;
          });
          this.disableSave = false;
        } 
        // if (addDocument.error) alert(addDocument.message);
        // else {
        //   this.close(true);
        // }
        this.close(true)
        this.upload_loader = false;
      },
      closeReferenceDocumentDialog() {
        this.output_dialog = false;
      },
      setSelectedReferenceDocument(document) {
        this.output_dialog = false;
        this.reference_status = true;

        const { documentDetails } = document;

        this.name = documentDetails.name;
        this.title = documentDetails.title;
        this.sender = documentDetails.sender;
        this.subject = documentDetails.subject;
        this.document_for = documentDetails.for;
        this.document_source = documentDetails.source;
        this.address = documentDetails.address;
        this.tag = documentDetails.tag;
        this.type = documentDetails.type;
        this.document_type = this.allDocumentTypes.find(
          (d) => d.id === documentDetails.document_type.id
        );
        this.referenced_transaction_id = documentDetails.transaction_id;
        this.referenced_document_id = documentDetails.id;
        this.referenced_document_count = documentDetails.document_count;
        this.referenced_refresh_year = documentDetails.refresh_year;
        this.isMainDocument = document.isMainDocument;
      },
      continueStep(step) {
        this.document_error_msg = null;
        if (step <= this.completed_step) {
          let body = {};

          if (step == 1) {
            body = {
              document_category: this.tag,
              document_type: this.document_type,
              document_tag: this.tag,
            };
          } else if (step == 2) {
            body = {
              subject: this.subject,
            };
          } else if (step == 3) {
            body = {
              sender: this.sender.name,
              recipients: this.document_for,
              source: this.document_source,
              address: this.address,
            };
          }
          console.log(body)
          let validate = validateDocument(step, body);
          if (validate.error) {
            this.document_error_msg = validate.errorMessage;
          } else {
            this.e6 = step + 1;
          }
        }

        if (step + 1 > this.completed_step) this.completed_step = step + 1;
      },
      moveStep(step) {
        if (step <= this.completed_step) {
          this.document_error_msg = null;
          this.e6 = step;
        }
      },
      changeDocumentTypeSelection() {
        let index = this.allDocumentCategories.findIndex(
          (e) => e.id === this.tag.id
        );

        if (index !== -1) {
          this.typeList = this.allDocumentCategories[index].document_types;
        }
      },
      onFileChange(e) {
        if(e){
          this.no_file_error = false;
          this.file_error_message = "";
          let inputFileType = e.name.substr(e.name.indexOf('.') + 1);
          let isAllowed = this.acceptedFileTypes.includes(inputFileType)
          if(isAllowed){
            this.disableSave = false;
            const file = e
            this.url = URL.createObjectURL(file);
            this.file = file;
            this.isFileAttached = true;
            if (file.type.includes("image")) this.file_type = "image";
            else if (file.type.includes("pdf")) this.file_type = "pdf";
            else if (file.type.includes("word")) this.file_type = "word";
            else if (file.type.includes("sheet")) this.file_type = "sheet";
            else this.file_type = "file";
          }else{
            this.disableSave = true;
            this.file_error_message = "Invalid file type. Please upload another one."
            this.no_file_error = true;
          }
        }else{
          this.file = null
          this.isFileAttached = false;
          this.url = null
          this.no_file_error = true;
          this.file_error_message = "No file attached"
          this.disableSave = true;
        }
      },
      removeSelectedRecipient(user_id) {
        let newDocuments = this.document_for.filter(
          (e) => e.user_id != user_id
        );
        this.document_for = newDocuments;
      },
    },
    created() {
      this.fetchDocumentTypes();
      this.fetchAllSenders();
      this.fetchDocumentCategories();
      if (this.isStandalone)
        this.fetchUsersInOffice()
    },
    computed: {
      ...mapGetters([
        "allDocumentTypes",
        "allSenders",
        "allDocumentCategories",
        "allUsersByOffice",
        "selectedSender"
      ]),
      computedTypes() {
        return this.typeList;
      },
      computedUsers() {
        return this.userList;
      },
    },
    watch: {
        dialog(){
            if(this.dialog){
                this.supp_docs = this.document.supporting_documents
                this.id = this.document.id
                this.tag = this.document.document_category
                this.document_type = this.allDocumentTypes.filter(type => type.id == this.document.document_type.id)[0]
                this.subject = this.document.subject
                this.name = this.document.name
                this.title = this.document.title
                this.sender = this.allSenders.filter(sender => sender.name == this.document.sender)[0]
                this.document_source = this.document.source
                this.address = this.document.address
                this.document_for = []
                this.addedReceivers.forEach(data => {
                    let user = this.allUsersByOffice.filter(user => user.user_id == data.user.id)
                    this.document_for.push(user[0])
                })
                this.url = `${fileSystemUrl}/view/${this.document.filepath_url}`
                this.isFileAttached = true
                if (this.document.file_type.includes("image")) this.file_type = "image";
                else if (this.document.file_type.includes("pdf")) this.file_type = "pdf";
                else if (this.document.file_type.includes("word")) this.file_type = "word";
                else if (this.document.file_type.includes("sheet")) this.file_type = "sheet";
                else this.file_type = "file";
                this.completed_step = 4
                this.e6 = 1
                this.filepath_url = this.document.filepath_url;
                this.date_uploaded = this.document.date_uploaded;
                this.user_uploaded = this.document.user_id;
                this.disableSave = false;
            }
        },
    }
  };
</script>

<style scoped>
  .select-document {
    cursor: pointer;
  }

  .stepper-header {
    cursor: pointer;
  }

  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 500px;
  }
</style>
